import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none",
  viewBox: "0 0 40 40",
  class: "user-badge-circle-exclamationmark_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "M26.667 10A8.333 8.333 0 1 1 10 10a8.333 8.333 0 0 1 16.667 0ZM1.667 28.972c0-1.344.717-2.59 1.89-3.281a29.096 29.096 0 0 1 16.624-3.967 11.62 11.62 0 0 0-2.68 7.442c0 2.125.567 4.117 1.56 5.833H4.523c-1.578 0-2.856-1.257-2.856-2.808v-3.219Z" }),
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M29.167 20a9.167 9.167 0 1 1 0 18.333 9.167 9.167 0 0 1 0-18.334Zm0 11.916a1.375 1.375 0 1 0 0 2.75 1.375 1.375 0 0 0 0-2.75Zm1.375-8.25h-2.75l.687 6.417h1.375l.688-6.417Z",
        "clip-rule": "evenodd"
      })
    ], -1)
  ]))]))
}
export default { render: render }